import React, { useState, useEffect, useRef } from 'react';
import getUsuarioStatusCode from 'EstruturaAntiga/actions/usuarios/getUsuarioStatusCode';
import ArrayUtils from 'utils/arrays';
import MasterPage from 'EstruturaAntiga/masterpages/authenticated';
import { Table, Flex, Input, Pagination } from 'antd';
import LoadingOrErrorPanel from 'components/LoadingOrErrorPanel';
import { usePagination } from 'store/usePagination';
import { useRoteiro } from 'context/RoteiroContext';
import UsuariosService from 'services/UsuariosService';
import BotoesAcaoListagem from './Components/BotoesAcaoListagem';
import DateUtils from 'utils/date';
import { NotificationManager } from 'react-notifications';
import { MessagesDefaultTimeout } from 'constants/messagesDefaultTimeout';
import { refNamesObjetosVisuaisUsuariosExcluidos } from 'constants/constantesRefNameObjetosVisuais';
import CONSTANTES_AMBIENTE from "constants/constantesAmbiente";
import useBloqueio from 'hooks/useBloqueio';
import { FuncionalidadePortalCliente } from 'constants/funcionalidadePortalCliente';
import { ModalInformativo } from 'components/Modais/ModalInformativo';

const ListagemRestaurar = ({history}) => {
    const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
    const { Search } = Input;

    const { setReferenciaObjetosVisuais } = useRoteiro();
    const refs = refNamesObjetosVisuaisUsuariosExcluidos.reduce((acc, name) => {
        acc[name] = useRef(null);
        return acc;
    }, {});

    const arrayRef = refNamesObjetosVisuaisUsuariosExcluidos.map(name => ({
        id: name,
        ref: refs[name],
    }));

    function obterReferenciaPorNome(refName) {
        return refs[refName] || null;
    }
    
    useEffect(() => {
        setTimeout(() => {
            setReferenciaObjetosVisuais(arrayRef);
        }, 1000);
    }, []);

    const listarUsuarios = async (tamanhoPagina = 10, filtro = '', skipToken = '') =>{
        const response = await UsuariosService.ListarUsuariosExcluidos(skipToken, filtro, tamanhoPagina);
        return response;
    }
    const {
        dados: usuarios,
        paginacaoLoading,
        paginacaoOpcoes,
        paginacaoErro,
        filtroAplicado,
        handleFiltro,
        handleAlteracaoDePaginacao,
    } = usePagination(listarUsuarios, 'usuarios', true);
    
    const { bloqueado: restauracaoBloqueada, mensagem: mensagemBloqueioRestauracao } = useBloqueio(FuncionalidadePortalCliente.RestauracaoUsuario);

    const handleRestaurarUsuario = (usuarioId) => {
        if (!usuarioId) return;

        if (restauracaoBloqueada) {
            ModalInformativo('Restauração de usuários indisponível', mensagemBloqueioRestauracao);
            return;
        }

        const usuarioStatus = statusUsuarios?.find(u => u.usuarioId === usuarioId);

        if (usuarioStatus && usuarioStatus.statuscode === CONSTANTES_AMBIENTE.TIPOS_STATUS_USUARIOS.EM_SINCRONIZACAO) {
            NotificationManager.info('O Usuário está sendo restaurado, por favor aguarde.', 'Atenção', MessagesDefaultTimeout.Warning);
            return;
        }
        history.push(`usuarios-excluidos/restaurar/${usuarioId}`);
    };

    const [statusUsuarios, setStatusUsuarios] = useState([]);

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'nomeParaExibicao',
            key: 'nomeParaExibicao',
            width: '100px',
        },
        {
            title: 'Login',
            dataIndex: 'userPrincipalName',
            key: 'userPrincipalName',
            width: '100px',
            ellipsis: true
        },
        {
            title: 'E-mail',
            dataIndex: 'emailPrincipal',
            key: 'maemailPrincipalil',
            width: '100px',
            ellipsis: true
        },
        {
            title: 'Data de Exclusão',
            dataIndex: 'dataExclusao',
            key: 'dataExclusao',
            width: '100px',
            render: (data) => DateUtils.DateFormat(new Date(data)),
        },
    ];

    const rowSelectionOnChange = (newSelectedRowKeys, selectedRows) =>{
        setLinhasSelecionadas(newSelectedRowKeys)
    }

    const rowSelection = {
        type: 'radio',
        selectedRowKeys: linhasSelecionadas,
        onChange: rowSelectionOnChange
    }

    const onSearch = (valorFiltro) => {
        setLinhasSelecionadas([])
        handleFiltro(valorFiltro)
    }
    const paginacaoOnChange = (paginaAtual, tamanhoPagina) =>{
        setLinhasSelecionadas([]);
        handleAlteracaoDePaginacao(paginaAtual, tamanhoPagina);
    }

    useEffect(() => {
        if (!usuarios || usuarios.length === 0) {
            setStatusUsuarios([]);
            return;
        }

        let isCancelled = false;

        const buscarStatusUsuarios = async () => {
            setStatusUsuarios([]); 
            const batchSize = 10;
            const lotesUsuarios = ArrayUtils.splitIntoBatches(usuarios, batchSize);
            
            for (const lote of lotesUsuarios) {
                if (isCancelled) return;

                const resultados = await Promise.all(
                    lote.map(async (usuario) => {
                        const resultado = await getUsuarioStatusCode(usuario.usuarioId);
                        if (!resultado) return null;
                        if (resultado?.statuscode === 204) {
                            resultado.axt_idobjetousuario365 = usuario.usuarioId;
                        }
                        return { ...resultado, usuarioId: usuario.usuarioId };
                    })
                );

                if (isCancelled) return;

                const novosStatus = resultados.filter(status => status !== null);
                setStatusUsuarios(prev => [...prev, ...novosStatus]);
            }
        };

        buscarStatusUsuarios();

        return () => {
            isCancelled = true;
        };
    }, [usuarios]);

    return (
        <MasterPage useFullWidth={!paginacaoErro.temErro && !paginacaoErro.temErro}>
            <LoadingOrErrorPanel nomeMenu={"Usuários Excluidos"} loading={paginacaoLoading} hasError={paginacaoErro.temErro}>
                <BotoesAcaoListagem restaurarButtonRef={obterReferenciaPorNome("refBotaoRestaurar")} handleRestaurarClick={() => handleRestaurarUsuario(linhasSelecionadas[0])} linhasSelecionadas={linhasSelecionadas} />
                <Table
                    rowKey={'usuarioId'}
                    columns={columns}
                    dataSource={usuarios}
                    bordered={false}
                    rowSelection={rowSelection}
                    size='small'
                    pagination={false}
                    onRow={(record) => {
                        return {
                            onClick: () => {rowSelectionOnChange([record.usuarioId], [record])},
                            onDoubleClick: () => handleRestaurarUsuario(record.usuarioId)
                        };
                    }}
                    title={() =>
                        <Flex justify='space-between' align='flex-start'>
                            <div>
                                <h3 style={{ fontSize: '28px', lineHeight: '32px', margin: 0 }}>Usuários Excluídos</h3>
                                <span style={{ fontSize: '12px' }}>É possível restaurar usuários excluídos nos últimos 30 dias. Após esse prazo, eles são removidos de forma definitiva.</span>
                            </div>
                            <div ref={obterReferenciaPorNome("refFiltroUsuarios")} >
                                <Search
                                    placeholder={"Filtrar por nome ou e-mail"}
                                    onSearch={onSearch}
                                    allowClear
                                    style={{width: 235}}
                                    defaultValue={filtroAplicado}
                                />
                            </div>
                        </Flex>
                    }
                    footer={() => 
                        <div ref={obterReferenciaPorNome("refPaginacaoUsuarios")} style={{ width:'fit-content' }}>
                            <Pagination 
                                defaultCurrent={1}
                                simple={{ readOnly: true }}
                                total={paginacaoOpcoes.total}
                                showTotal={(total) => `Total: ${total}`}
                                pageSize={paginacaoOpcoes.tamanhoPagina}
                                onChange={paginacaoOnChange}
                                disabled={paginacaoLoading}
                                showSizeChanger={paginacaoOpcoes.total > 10}
                                current={paginacaoOpcoes.paginaAtual}
                                locale={{ items_per_page: '/ página' }}
                            />
                        </div>
                    }
                />
            </LoadingOrErrorPanel>
        </MasterPage>
    );
};

export default ListagemRestaurar;
